/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  GoalSummaryDto,
  GoalSummaryRequest
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType , BodyType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const generateGoalSummary = (
    userId: string,
    goalSummaryRequest: BodyType<GoalSummaryRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GoalSummaryDto>(
      {url: `/api/${userId}/goal-summary`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: goalSummaryRequest, signal
    },
      options);
    }



export const getGenerateGoalSummaryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateGoalSummary>>, TError,{userId: string;data: BodyType<GoalSummaryRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof generateGoalSummary>>, TError,{userId: string;data: BodyType<GoalSummaryRequest>}, TContext> => {

const mutationKey = ['generateGoalSummary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateGoalSummary>>, {userId: string;data: BodyType<GoalSummaryRequest>}> = (props) => {
          const {userId,data} = props ?? {};

          return  generateGoalSummary(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateGoalSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof generateGoalSummary>>>
    export type GenerateGoalSummaryMutationBody = BodyType<GoalSummaryRequest>
    export type GenerateGoalSummaryMutationError = ErrorType<unknown>

    export const useGenerateGoalSummary = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateGoalSummary>>, TError,{userId: string;data: BodyType<GoalSummaryRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateGoalSummary>>,
        TError,
        {userId: string;data: BodyType<GoalSummaryRequest>},
        TContext
      > => {
      return useMutation(getGenerateGoalSummaryMutationOptions(options), queryClient);
    }
